
import { CertificationsForm } from '@gtpl/pages/master/master-components/certifications-form';
import { CertificationsGrid } from '@gtpl/pages/master/master-components/certifications-grid';
import { PaymentModesGrid } from '@gtpl/pages/master/master-components/payment-modes-grid';
import { PaymentModesForm } from '@gtpl/pages/master/master-components/payment-modes-form';
import { SaleOrderTypesForm } from '@gtpl/pages/master/master-components/sale-order-types-form';
import { SaleOrderTypesGrid } from '@gtpl/pages/master/master-components/sale-order-types-grid';
import { UomsForm } from '@gtpl/pages/master/master-components/uoms-form';
import { UomsGrid } from '@gtpl/pages/master/master-components/uoms-grid';
import { PackingMehodsForm } from '@gtpl/pages/master/master-components/packing-methods-form';
import { PackingMethodsGrid } from '@gtpl/pages/master/master-components/packing-methods-grid';
import { DestinationForm } from '@gtpl/pages/master/master-components/destination-form';
import { DestinationGrid } from '@gtpl/pages/master/master-components/destination-grid';
import { EndCustomersForm } from '@gtpl/pages/master/master-components/end-customer-form';
import { EndCustomerGrid } from '@gtpl/pages/master/master-components/end-customer-grid'
import { TaxesGrid } from '@gtpl/pages/master/master-components/taxes-grid';
import { TaxesForm } from '@gtpl/pages/master/master-components/taxes-form';
import { CurrenciesForm } from '@gtpl/pages/master/master-components/currencies-form';
import { CurrenciesGrid } from '@gtpl/pages/master/master-components/currencies-grid';
import { CountriesForm } from '@gtpl/pages/master/master-components/countries-form';
import { CountriesGrid } from '@gtpl/pages/master/master-components/countries-grid';
import { ProductsForm } from '@gtpl/pages/master/master-components/products-form';
import { ProductsGrid } from '@gtpl/pages/master/master-components/products-grid';
import { DepartmentsGrid } from '@gtpl/pages/master/master-components/departments-grid';
import { DepartmentsForm } from '@gtpl/pages/master/master-components/departments-form';
import { TypeOfValueAddition1Form } from '@gtpl/pages/master/master-components/type-of-value-addition1-form';
import { TypeOfValueAddition1Grid } from '@gtpl/pages/master/master-components/type-of-value-addition1-grid';
import { GradeGrid } from '@gtpl/pages/master/master-components/grades-grid';
import { GradeForm } from '@gtpl/pages/master/master-components/grades-form';
import { TypeOfValueAddition2Grid } from '@gtpl/pages/master/master-components/type-of-value-addition2-grid';
import { TypeOfValueAddition2Form } from '@gtpl/pages/master/master-components/type-of-value-addition2-form';
import { TypeOfValueAddition3Grid } from '@gtpl/pages/master/master-components/type-of-value-addition3-grid';
import { TypeOfValueAddition3Form } from '@gtpl/pages/master/master-components/type-of-value-addition3-form';
import { TypeOfValueAddition4Form } from '@gtpl/pages/master/master-components/type-of-value-addition4-form';
import { TypeOfValueAddition4Grid } from '@gtpl/pages/master/master-components/type-of-value-addition4-grid';

import { SkuDetailView, SkuForm } from '@gtpl/pages/master/master-components/sku-form';
import { SkuGrid } from '@gtpl/pages/master/master-components/sku-grid';
import { HsnCodesForm } from '@gtpl/pages/master/master-components/hsn-codes-form';
import { HsnCodesGrid } from '@gtpl/pages/master/master-components/hsn-codes-grid';
import { PaymentTermsForm } from '@gtpl/pages/master/master-components/payment-terms-form';
import { PaymentTermsGrid } from '@gtpl/pages/master/master-components/payment-terms-grid';
import { CustomersGrid } from '@gtpl/pages/master/master-components/customers-grid';
import { CustomersForm } from '@gtpl/pages/master/master-components/customers-form';
import { TypeOfFoodGrid } from '@gtpl/pages/master/master-components/type-of-food-grid';
import { TypeOfFoodForm } from '@gtpl/pages/master/master-components/type-of-food-form';
import { DeliveryTermsGrid } from '@gtpl/pages/master/master-components/delivery-terms-grid';
import { DeliveryTermsForm } from '@gtpl/pages/master/master-components/delivery-terms-form';
import { ShippingTermsGrid } from '@gtpl/pages/master/master-components/shipping-terms-grid';
import { ShippingTermsForm } from '@gtpl/pages/master/master-components/shipping-terms-form';

import { ItemCategoriesForm } from '@gtpl/pages/master/master-components/item-categories-form';
import { ItemCategoriesGrid } from '@gtpl/pages/master/master-components/item-categories-grid';

import { ItemDamageReasonsForm } from '@gtpl/pages/master/master-components/item-damage-reasons-form';
import { ItemDamageReasonsGrid } from '@gtpl/pages/master/master-components/item-damage-reasons-grid';

import { VendorsForm } from '@gtpl/pages/master/master-components/vendors-form';
import { VendorsGrid } from '@gtpl/pages/master/master-components/vendors-grid';

import { ReasonsForm } from '@gtpl/pages/master/master-components/reasons-form';
import { ReasonsGrid } from '@gtpl/pages/master/master-components/reasons-grid';

import { UnitCodeForm } from '@gtpl/pages/master/master-components/unit-code-form';
import { UnitCodeGrid } from '@gtpl/pages/master/master-components/unit-code-grid'

import { ItemsForm } from '@gtpl/pages/master/master-components/items-form';
import { ItemsGrid } from '@gtpl/pages/master/master-components/items-grid';
import { GrnRejectionReasonsForm } from '@gtpl/pages/master/master-components/grn-rejection-reasons-form';
import { GrnRejectionReasonsGrid } from '@gtpl/pages/master/master-components/grn-rejection-reasons-grid';

import { SizesForm } from '@gtpl/pages/master/master-components/sizes-form';
import { SizesGrid } from '@gtpl/pages/master/master-components/sizes-grid';

import { HatcheriesForm } from '@gtpl/pages/master/master-components/hatcheries-form';
import { HlPercentagesForm } from '@gtpl/pages/master/master-components/hl-percentages-form';
import { HatcheriesGrid } from '@gtpl/pages/master/master-components/hatcheries-grid';
import { HlPercentagesGrid } from '@gtpl/pages/master/master-components/hl-percentages-grid';
import { SuppliersGrid } from '@gtpl/pages/master/master-components/suppliers-grid';
import { SuppliersForm } from '@gtpl/pages/master/master-components/suppliers-form';
import { TypeOfValueAddition5Form } from '@gtpl/pages/master/master-components/type-of-value-addition5-form';
import { TypeOfValueAddition5Grid } from '@gtpl/pages/master/master-components/type-of-value-addition5-grid';
import { VendorPriceListGrid } from '@gtpl/pages/master/master-components/vehicle-price-list-grid';
import { VendorPriceListForm } from '@gtpl/pages/master/master-components/vehicle-price-list-form';
import { LevelGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/level-grid';
import { LevelForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/level-form';
import { PalletGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/pallet-grid';
import { PalletForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/pallet-form';
import { ColumnsGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/columns-grid';
import { ColumnsForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/columns-form';
import { RackGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/rack-grid'
import { RackForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/rack-form'
import { RacksMasterGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/racks-master-grid';
import { RacksMasterForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/racks-master-form'
import { ZoneGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/zone-grid'
import { ZoneForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/zone-form';
import { RackEndcustomerMappingForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/rack-endcustomer-mapping-form';
import { RackEndcustomerMappingGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/rack-endcustomer-mapping-grid';
import { LocationsGrid } from '@gtpl/pages/warehouse-masters/warehouse-master-component/locations-grid';
import { LocationsForm } from '@gtpl/pages/warehouse-masters/warehouse-master-component/locations-form';

import { MasterBrandsForm } from '@gtpl/pages/master/master-components/master-brands-form';
import { MasterBrandsGrid } from '@gtpl/pages/master/master-components/master-brands-grid';
import { ExpensesCategoryGrid } from '@gtpl/pages/hrms/hrms-components/expenses-category-grid';
import { ExpensesSubCategory } from '@gtpl/pages/hrms/hrms-components/expenses-sub-category';
import { ExpensesSubCategoryGrid } from '@gtpl/pages/hrms/hrms-components/expenses-sub-category-grid';
import { Skills } from '@gtpl/pages/hrms/hrms-components/skills';
import { SkillsGrid } from '@gtpl/pages/hrms/hrms-components/skills-grid';
import { Designation } from '@gtpl/pages/hrms/hrms-components/designation';
import { DesignationGrid } from '@gtpl/pages/hrms/hrms-components/designation-grid';
import { TransferActionForm } from '@gtpl/pages/hrms/hrms-components/transfer-action-form';
import { TransferActionGrid } from '@gtpl/pages/hrms/hrms-components/transfer-action-grid';
import { HolidaysCalender } from '@gtpl/pages/hrms/hrms-components/holidays-calender';
import { HolidaysCalenderGrid } from '@gtpl/pages/hrms/hrms-components/holidays-calender-grid';
import { EmploymentStatusForm } from '@gtpl/pages/hrms/hrms-components/employment-status-form';
import { EmploymentStatusGrid } from '@gtpl/pages/hrms/hrms-components/employment-status-grid';
import { ItemSubCategoriesForm } from '@gtpl/pages/master/master-components/item-sub-categories-form';
import { ItemSubCategoriesGrid } from '@gtpl/pages/master/master-components/item-sub-categories-grid';
import { IdProofs } from '@gtpl/pages/hrms/hrms-components/id-proofs';
import { IdProofsGrid } from '@gtpl/pages/hrms/hrms-components/id-proofs-grid';
import { Relations } from '@gtpl/pages/hrms/hrms-components/relations';
import { RelationsGrid } from '@gtpl/pages/hrms/hrms-components/relations-grid';
import { LoanCategoriesGrid } from '@gtpl/pages/hrms/hrms-components/loan-categories-grid';
import { LoanCategories } from '@gtpl/pages/hrms/hrms-components/loan-categories';
import { OverTimeCategoryGrid } from '@gtpl/pages/hrms/hrms-components/over-time-category-grid';
import { OverTimeCategory } from '@gtpl/pages/hrms/hrms-components/over-time-category';
import { ComplaintsGrid } from '@gtpl/pages/hrms/hrms-components/complaints-grid';
import { Complaints } from '@gtpl/pages/hrms/hrms-components/complaints';
import { TypesOfLeaves } from '../../../../../libs/pages/hrms/hrms-components/types-of-leaves/src';
import { TypesOfLeavesGrid } from '../../../../../libs/pages/hrms/hrms-components/types-of-leaves-grid/src'
import { Education } from '@gtpl/pages/hrms/hrms-components/education';
import { EducationGrid } from '@gtpl/pages/hrms/hrms-components/education-grid';
import { Certification } from '@gtpl/pages/hrms/hrms-components/certification';
import { CertificationGrid } from '@gtpl/pages/hrms/hrms-components/certification-grid';
import { NotifyPartyGrid } from '@gtpl/pages/master/master-components/notify-party-grid';
import { NotifyPartyForm } from '@gtpl/pages/master/master-components/notify-party-form';
import { TypesForm } from '@gtpl/pages/master/master-components/types-form';
import { TypesGrid } from '@gtpl/pages/master/master-components/types-grid';
import { TeamGrid } from '@gtpl/pages/hrms/hrms-components/teams-grid';
import { TeamForm } from '@gtpl/pages/hrms/hrms-components/teams-form';
import { ShiftGrid } from '@gtpl/pages/hrms/hrms-components/shifts-grid';
import { ShiftForm } from '@gtpl/pages/hrms/hrms-components/shifts';
import { RmLevelForm } from '@gtpl/pages/master/master-components/rm-level-form';
import { RmLevelGrid } from '@gtpl/pages/master/master-components/rm-level-grid';
import { RmColumnsForm } from '@gtpl/pages/master/master-components/rm-columns-form';
import { RmColumnsGrid } from '@gtpl/pages/master/master-components/rm-columns-grid';
import { RmRackPositionGrid } from '@gtpl/pages/master/master-components/rm-rack-position-grid';
import { RmRackPositionForm } from '@gtpl/pages/master/master-components/rm-rack-position-form';
import { RmRacksForm } from '@gtpl/pages/master/master-components/rm-racks-form';
import { RmRacksGrid } from '@gtpl/pages/master/master-components/rm-racks-grid';
import { DefectForm } from '@gtpl/pages/master/master-components/defect-form';
import { DefectGrid } from '@gtpl/pages/master/master-components/defect-grid';
import { DowntimeReasonForm } from '@gtpl/pages/master/master-components/downtime-reason-form';
import { DowntimeReasonGrid } from '@gtpl/pages/master/master-components/downtime-reason-grid';
import { TrimsGrid } from '@gtpl/pages/master/master-components/shrimps-grid';
import { TrimsMappingGrid } from '@gtpl/pages/master/master-components/trims-mapping-grid';
import { TrimsForm } from '@gtpl/pages/master/master-components/shrimps-form';
import { ExpensesCategory } from '@gtpl/pages/hrms/hrms-components/expenses-category';
import { QualificationsGrid } from '@gtpl/pages/hrms/hrms-components/qualifications-grid';
import { RecruitmentForm } from '@gtpl/pages/hrms/hrms-components/recruitment-mode-form';
import { RecruitmentGrid } from '@gtpl/pages/hrms/hrms-components/recruitment-mode';
import { QualificationsForm } from '@gtpl/pages/hrms/hrms-components/qualifications';
import { TrimsConfigurationForm } from '@gtpl/pages/master/master-components/trims-configuration-form'
import { PalletCapacityGrid } from '@gtpl/pages/master/master-components/pallet-capacity-grid';
import { PalletCapacityForm } from '@gtpl/pages/master/master-components/pallet-capacity-form';
import { EmployeeRolesEnum, UiConfig } from '@gtpl/shared-models/common-models';
import { InsuranceForm } from '@gtpl/pages/master/master-components/insurance-form'
import { InsuranceGrid } from '@gtpl/pages/master/master-components/insurance-grid'
import { SpecSheetGrid } from '@gtpl/pages/master/master-components/spec-sheet-grid';
import { SpecSheetForm } from '@gtpl/pages/master/master-components/spec-sheet-form';
import { RmToleranceGrid } from '@gtpl/pages/master/master-components/rm-tolerance-grid';
import { RmToleranceForm } from '@gtpl/pages/master/master-components/rm-tolerance-form';
import { VehicleMasterForm } from '@gtpl/pages/master/master-components/vehicle-master-form';
import { VehicleMasterGrid } from '@gtpl/pages/master/master-components/vehicle-master-grid';
import { ResourceOperationEfficiencyGrid } from '@gtpl/pages/planning/planning-components/resource-operation-efficiency-grid'
import { ResourceOperationEfficiencyForm } from '@gtpl/pages/planning/planning-components/resource-operation-efficiency-form'
import { PlantCapacityForm } from '@gtpl/pages/planning/planning-components/plant-capacity-form'
import { VariantOperationsForm } from '@gtpl/pages/production-management/production-management-components/variant-operations-form';
import { WorkstationCategoryForm } from '@gtpl/pages/production-management/production-management-components/workstation-category-form';
import { WorkstationCategoryGrid } from '@gtpl/pages/production-management/production-management-components/workstation-category-grid';
import { OperationsForm } from '@gtpl/pages/production-management/production-management-components/operations-form';
import { OperationsGrid } from '@gtpl/pages/production-management/production-management-components/operations-grid';
import { WorkstationsGrid } from '@gtpl/pages/production-management/production-management-components/workstations-grid';
import { PlantOperationCapacityForm } from '@gtpl/pages/master/master-components/plant-operation-capacity-form';
import { PlantOperationCapacityGrid } from '@gtpl/pages/master/master-components/plant-operation-capacity-grid';
import { UserForm } from '@gtpl/pages/user-management/user-components/user-form';
import { GradeSuggestionFrom } from '@gtpl/pages/master/master-components/grade-suggestion-from';
// import  { DeheadingRates } from '@gtpl/pages/master/master-components/deheading-rates'
import { QaQcGrid } from '@gtpl/pages/qa-qc/qa-qc-components/qa-qc-grid';
import { QaQcOperations } from '@gtpl/pages/qa-qc/qa-qc-components/qa-qc-operations';
import { CodeListGrid, CodeListPrint } from '@gtpl/pages/planning/planning-components/code-list-grid';
import { CodeListForm } from '@gtpl/pages/planning/planning-components/code-list-form';
import { RolesForm } from '@gtpl/pages/master/master-components/roles-form';
import { RolesGrid } from '@gtpl/pages/master/master-components/roles-grid';
import { RouteGrid } from 'libs/pages/master/master-components/route-grid/src';
import { RouteForm } from 'libs/pages/master/master-components/route-form/src';
import { AssetActivityControllerForm } from '@gtpl/shared-components/asset-activity-controller';
import { AssetActivityControllerGrid } from '@gtpl/shared-components/asset-activity-controller';
import { AssetCategory } from 'libs/pages/asset-management/asset-management-components/asset-po-grid/src/lib/pages-asset-management-asset-management-components-asset-po-grid';
// import { AssetCategoryForm } from 'libs/pages/asset-management/asset-management-components/asset-po-form/src/lib/pages-asset-management-asset-management-components-asset-po-form';
import React, { useState } from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import AssetLocation from 'libs/pages/asset-management/asset-management-components/dc-grid/src/lib/pages-asset-management-asset-management-components-dc-grid';
import locationForm from 'libs/pages/asset-management/asset-management-components/dc-form/src/lib/pages-asset-management-asset-management-components-dc-form';
import CheckListForm from 'libs/pages/asset-management/asset-management-components/dc-form/src/lib/asset-checklist-form';
import CheckListGrid from 'libs/pages/asset-management/asset-management-components/dc-form/src/lib/asset-checklist-grid';
import { ExchangeRatesForm, ExchangeRatesGrid } from '@gtpl/pages/master/master-components/exchange-rates'
import { FgPricelistForm } from '../../../../../libs/pages/master/master-components/fg-pricelist/src/lib/fg-pricelist-form'
import { FgPriceListGrid } from '../../../../../libs/pages/master/master-components/fg-pricelist/src/lib/fg-price-list-grid'

// import {RmCountPriceListForm} from 'libs/pages/master/master-components/rm-count-pricelist/src/lib/rm-count-pricelist-form'
// import {RmCountPriceListGrid} from '././../../../../../libs/pages/master/master-components/rm-count-pricelist/src/lib/rm-count-price-list-grid'
import { FixedComponentsRateChartForm } from 'libs/pages/master/master-components/fixed-components-rate-chart/src/lib/fixed-components-rate-chart-excel-upload'
import { FixedComponentsRateChartGrid } from 'libs/pages/master/master-components/fixed-components-rate-chart/src/lib/fixed-components-rate-chart-grid'

import { DeheadingPeelingGrid } from '././../../../../../libs/pages/master/master-components/deheading-peeling/src/lib/deheading-peeling-grid'
import { DeheadingPeelingForm } from '././../../../../../libs/pages/master/master-components/deheading-peeling/src/lib/deheading-peeling-form'
import { GlobalPriceChartGrid } from '././../../../../../libs/pages/master/master-components/global-price-chart/src/lib/global-price-chart.grid'
import { FreightsCompanyView } from '././../../../../../libs/pages/master/master-components/freights-company/src/lib/freights-company-view'
import { FreightsCompanyForm } from '././../../../../../libs/pages/master/master-components/freights-company/src/lib/freights-company-form'
import { RmCountPriceListGrid } from './../../../../../libs/pages/raw-material-procurement/raw-material-procurement-components/rm-count-pricelist/src/lib/rm-count-price-list-grid'
import { RmCountPriceListForm } from './../../../../../libs/pages/raw-material-procurement/raw-material-procurement-components/rm-count-pricelist/src/lib/rm-count-pricelist-form'
import { OcaenFreightRatesExcelUpload } from '../../../../../libs/pages/master/master-components/ocaen-freight-rates/src/lib/ocaen-freight-rates'
import { OcaenFreightRatesView } from '../../../../../libs/pages/master/master-components/ocaen-freight-rates/src/lib/ocaen-freight-rates-view'
import { FarmersGrid } from '../../../../../libs/pages/master/master-components/farmers/src/lib/farmers-view'
import { FarmersExcelUpload } from '../../../../../libs/pages/master/master-components/farmers/src/lib/farmers-excel-upload'
import { DebitCreditPrint } from '../../../../../libs/pages/finance/adjustment-note/src';
import { PackingMaterialPricesGrid } from '../../../../../libs/pages/master/master-components/packing-material-prices/src/lib/packing-material-prices-grid'
import PackingMaterialPricesForm from '../../../../../libs/pages/master/master-components/packing-material-prices/src/lib/packing-material-prices-excel-upload'
import { SoakStyleGrid } from '../../../../../libs/pages/master/master-components/soack-style-grid/src/lib/soak-style-grid'
import BankDetailsForm from '../../../../../libs/pages/master/master-components/bank-details/src/lib/bank-details-form'
import BankDetailsView from '../../../../../libs/pages/master/master-components/bank-details/src/lib/bank-details-view'
import SoakStyleForm from 'libs/pages/master/master-components/soack-style-form/src/lib/soak-style-form';
import { FinanceExpenses, FinanceExpensesView } from '@gtpl/pages/finance/expenses'

import AssetCategoryForm from 'libs/pages/asset-management/asset-management-components/asset-po-form/src/lib/pages-asset-management-asset-management-components-asset-po-form';
import { AssetCheckListDto, AssetsCatagoryDto } from '@gtpl/shared-models/asset-management';
import {TallyUploadFiles} from '../../../../../libs/pages/master/master-components/tally-upload-files/src/lib/tally-upload-files'
import{StockItemCategoryView} from '../../../../../libs/pages/master/master-components/stock-item-category/src/lib/stock-item-category-view'
import{StockItemCategory} from '../../../../../libs/pages/master/master-components/stock-item-category/src/lib/stock-item-category'
import {VendorBanksUpload} from '../../../../../libs/pages/master/master-components/vendor-banks/src/lib/vendor-banks'
import {VendorBanksView}  from '../../../../../libs/pages/master/master-components/vendor-banks/src/lib/vendor-banks-view'
import RmZones from 'libs/pages/master/master-components/rm-level-grid/src/lib/rm-zones';
import {RmBudget} from 'libs/pages/finance/rm-budget/src'
import {RMBudgetGrid} from 'libs/pages/finance/rm-budget/src/lib/rm-budget-view'
import {SaleBudget} from 'libs/pages/finance/sale-budget/src'
import {SaleBudgetGrid} from 'libs/pages/finance/sale-budget/src/lib/sale-budget-view'
import deheadingRates from 'libs/pages/master/master-components/deheading-rates/src/lib/deheading-rates';
import DeheadingRatesGrid from 'libs/pages/master/master-components/deheading-rates/src/lib/deheading-rates-grid';
import VillageTransportCost from 'libs/pages/master/master-components/deheading-rates/village-transport-cost/village-transport-cost';
import VillageTransportGrid from 'libs/pages/master/master-components/deheading-rates/village-transport-cost/village-transport-cost-grid';

import {PreProductionWorkersForm} from 'libs/pages/master/master-components/pre-production-workers/src/lib/pre-production-workers'
import {PreProductionWorkersView} from 'libs/pages/master/master-components/pre-production-workers/src/lib/pre-production-workers-view'
import {TallyView} from '../../../../../libs/pages/master/master-components/tally-upload-files/src/lib/tally-upload-files-view'

export const MastersRoute = () => {

    const [soakingDashboardUpdateKey, setSoakingDashboardUpdateKey] = useState<number>(1)

    console.log(soakingDashboardUpdateKey, 'update key');
    const updateSoakingDashboardState = (value) => {
        setSoakingDashboardUpdateKey(soakingDashboardUpdateKey + value)
    }

    return (
        <>
            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON)||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                <>
                    {/* ------------------------Global in masters------------------ */}
                    <Route exact path="/certificates-view" component={CertificationsGrid} />
                    <Route exact path="/Countries-view" component={CountriesGrid} />
                    <Route exact path="/destination-view" component={DestinationGrid} />
                    <Route exact path="/Currencies-view" component={CurrenciesGrid} />
                    <Route exact path="/customers-view" component={CustomersGrid} />
                    <Route exact path="/delivery-terms-view" component={DeliveryTermsGrid} />
                    <Route exact path="/Packingmethods-view" component={PackingMethodsGrid} />
                    <Route exact path="/Payment-modes-view" component={PaymentModesGrid} />
                    <Route exact path="/payment-terms-view" component={PaymentTermsGrid} />
                    <Route exact path="/shipping-terms-view" component={ShippingTermsGrid} />
                    <Route exact path="/taxes-view" component={TaxesGrid} />
                    <Route exact path="/UOMs-view" component={UomsGrid} />

                    <Route exact path="/unitcode-view" component={UnitCodeGrid} />
                </>
            }

            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&
                <>
                    {/* ------------------------Global in masters------------------ */}

                    <Route exact path="/certificates-form" render={props => <CertificationsForm certificationData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateCertification={(undefined) => { }}
                    />} />

                    <Route exact path="/Countries-form" render={props => <CountriesForm countryData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }} />}
                    />

                    <Route exact path="/destination-form" render={props => <DestinationForm destinatonData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />

                    <Route exact path="/Currencies-form" render={props => <CurrenciesForm currencyData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }} />}
                    />

                    <Route exact path="/customers-form" render={props => <CustomersForm customersData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }} />}
                    />

                    <Route exact path="/delivery-terms-form" render={props => <DeliveryTermsForm deliverytermsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />
                    <Route exact path="/Packingmethods-form" render={props => <PackingMehodsForm packingMehodData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePackingMethod={(undefined) => { }}
                    />} />

                    <Route exact path="/Payment-modes-form" render={props => <PaymentModesForm paymentmodeData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePaymentmode={(undefined) => { }}
                    />} />
                    <Route exact path="/payment-terms-form" render={props => <PaymentTermsForm paymentTermsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />
                    <Route exact path="/shipping-terms-form" render={props => <ShippingTermsForm shippingtermsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />

                    <Route exact path="/taxes-form" render={props => <TaxesForm taxesData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateTax={(undefined) => { }}
                    />} />
                    <Route exact path="/UOMs-form" render={props => <UomsForm uomsData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }}
                    />} />

                    <Route exact path="/unitcode-form" render={props => <UnitCodeForm unitcodeData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateUnitcode={(undefined => { })}
                    />} />
                </>
            }
            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                <>
                    {/* --------------------------------Sales ------------------------------------ */}
                    <Route exact path="/master-brands-grid" component={MasterBrandsGrid} />
                </>
            }

            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&
                <>
                    {/* --------------------------------Sales ------------------------------------ */}
                    <Route exact path="/master-brands-form" render={props => <MasterBrandsForm masterBrandData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateMasterBrand={(undefined => { })} />
                    } />
                </>
            }

            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON)) &&
                <>
                    <Route exact path="/EndCustomerview" component={EndCustomerGrid} />

                    <Route exact path="/Grades-view" component={GradeGrid} />

                    <Route exact path="/typeofFood-view" component={TypeOfFoodGrid} />

                    <Route exact path="/Products-view" component={ProductsGrid} />

                    <Route exact path="/specsheet-view" component={SpecSheetGrid} />

                    <Route exact path="/valueaddition1-view" component={TypeOfValueAddition1Grid} />

                    <Route exact path="/valueaddition2-view" component={TypeOfValueAddition2Grid} />
                    <Route exact path="/valueaddition3-view" component={TypeOfValueAddition3Grid} />

                    <Route exact path="/valueaddition4-view" component={TypeOfValueAddition4Grid} />

                    <Route exact path="/valueaddition5-view" component={TypeOfValueAddition5Grid} />


                    <Route exact path="/sku-view" component={SkuGrid} />

                    <Route exact path="/hsn-view" component={HsnCodesGrid} />

                </>}

            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)|| (JSON.parse(localStorage.getItem('role'))===EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON) ||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) ) &&
                <>

                    <Route exact path="/EndCustomerform" render={props => <EndCustomersForm endCustomersData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined => { })}
                    />} />

                    <Route exact path="/Grades-form" render={props => <GradeForm gradesData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateGrade={(undefined) => { }}
                    />} />

                    <Route exact path="/typeofFood-form" render={props => <TypeOfFoodForm foodTypeData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined => { })}
                    />} />

                    <Route exact path="/Products-form" render={props => <ProductsForm productData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePoduct={(undefined) => { }}
                    />} />

                    <Route exact path="/spec-sheet-form" render={props => <SpecSheetForm specsheetData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }}
                    />}
                    />

                    <Route exact path="/tally-upload-files" render={props => <TallyUploadFiles poUploadData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }}
                    />}
                    />
                      <Route exact path="/tally-files-view" component={TallyView} />

                    <Route exact path="/valueaddition1-form" render={props => <TypeOfValueAddition1Form type1Data={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateType1={(undefined) => { }}
                    />} />

                    <Route exact path="/valueaddition2-form" render={props => <TypeOfValueAddition2Form TypesOfValueAddition2Data={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateTypesOfValueAddition2Dto={(undefined) => { }}
                    />} />
                    <Route exact path="/valueaddition3-form" render={props => <TypeOfValueAddition3Form TypesOfValueAddition3Data={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateTypesOfValueAddition3Dto={(undefined) => { }}
                    />} />

                    <Route exact path="/valueaddition4-form" render={props => <TypeOfValueAddition4Form productData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePoduct={(undefined) => { }}
                    />} />

                    <Route exact path="/valueaddition5-form" render={props => <TypeOfValueAddition5Form productData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updatePoduct={(undefined) => { }}
                    />} />
                    <Route exact path="/sku-form" render={props => <SkuForm skuData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateSku={(undefined => { })}
                    />} />
                    <Route exact path="/hsn-form" render={props => <HsnCodesForm hsnData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateHsn={(undefined => { })}
                    />} />
                </>}






            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&
                <>
                    <Route exact path='/insurance-view' component={InsuranceGrid} />
                    <Route exact path='/insurance-form' component={InsuranceForm} />
                    <Route exact path="/notify-party-grid" component={NotifyPartyGrid} />
                    <Route exact path="/notify-party-form" render={props => <NotifyPartyForm
                        notifyPartyData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateNotifyParty={(undefined => { })}
                    />
                    } />
                    <Route exact path="/team-view" component={TeamGrid} />
                    <Route exact path="/team-form" component={TeamForm} />
                    <Route exact path="/shift-view" component={ShiftGrid} />
                    <Route exact path="/shift-form" component={ShiftForm} />
                </>}

            <Route exact path="/location-Form" component={locationForm} />
            <Route exact path="/asset-checklist-form" render={(routeProps: RouteComponentProps) => (
                <CheckListForm
                    {...routeProps}
                    checkListData={undefined}
                    updateCheckList={(items: AssetCheckListDto): void => {
                        throw new Error("Function not implemented.");
                    }}
                    isUpdate={false}
                    closeForm={(): void => {
                        throw new Error("Function not implemented.");
                    }}
                    setDrawerVisible={undefined}
                />
            )} />
            <Route exact path="/asset-checklist-grid" component={CheckListGrid} />
            <Route exact path="/asset-Location" component={AssetLocation} />
            <Route exact path="/asset-category" component={AssetCategory} />
            <Route
                exact
                path="/asset-category-form"
                render={(routeProps: RouteComponentProps) => (
                    <AssetCategoryForm
                        {...routeProps}
                        assetCategoryData={undefined}
                        updateCategory={(items: AssetsCatagoryDto): void => {
                            throw new Error("Function not implemented.");
                        }}
                        isUpdate={false}
                        closeForm={(): void => {
                            throw new Error("Function not implemented.");
                        }}
                        setDrawerVisible={undefined}
                    />
                )}
            />
            <Route exact path="/Asset-view" component={AssetCategory}
            // render={props => <AssetActivityControllerForm updateState={updateSoakingDashboardState}
            //     isUpdate={false}
            //     closeForm={() => { }}
            // />}
            />

            <Route exact path="/Finance-expenses" component={FinanceExpenses} />
            <Route exact path="/Finance-expenses-view" component={FinanceExpensesView} />

            <Route exact path="/Asset-grid" render={props => <AssetActivityControllerGrid updateState={updateSoakingDashboardState} />} />
            {/* <Route exact path="/Asset-grid" component={AssetActivityControllerGrid} /> */}
            <Route exact path='/over-time-categories-grid' component={OverTimeCategoryGrid} />
            <Route exact path="/over-time-categories-form" component={OverTimeCategory} />
            <Route exact path="/code-list-form" render={props => <CodeListForm codeListData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateCodeList={(undefined) => { }}
            />} />
            <Route exact path="/code-list-grid" component={CodeListGrid} />
            <Route exact path="/qa-qc-operations" component={QaQcOperations} />
            <Route exact path="/qa-qc-grid" component={QaQcGrid} />
            <Route exact path="/grade-suggestion" component={GradeSuggestionFrom} />
            <Route exact path="/deheading-rates" component={deheadingRates} />
            <Route exact path="/deheading-rates-grid" component={DeheadingRatesGrid} />
            <Route exact path="/village-transport-cost" component={VillageTransportCost} />
            <Route exact path="/village-transport-cost-grid" component={VillageTransportGrid} />

            
            <Route exact path="/workers-grid" component={PreProductionWorkersView} />
            <Route exact path="/worker" component={PreProductionWorkersForm} />

            <Route exact path="/user-form" component={UserForm} />
            <Route exact path="/plant-operation-capacity-form" component={PlantOperationCapacityForm} />
            <Route exact path="/plant-operation-capacity-view" component={PlantOperationCapacityGrid} />
            <Route exact path="/workstations-grid" component={WorkstationsGrid} />
            <Route exact path="/operations-view" component={OperationsGrid} />
            <Route exact path="/operations-form" render={props => <OperationsForm
                operationData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateOperation={(undefined => { })} />
            } />
            <Route exact path="/workstation-category-form" render={props => <WorkstationCategoryForm workstationCategoryData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateWorkstationCategory={(undefined => { })} />} />
            <Route exact path="/workstation-category-grid" component={WorkstationCategoryGrid} />

            <Route exact path="/varient-operations-form" component={VariantOperationsForm} />
            <Route exact path="/resource-op-efficiency-view" component={ResourceOperationEfficiencyGrid} />
            <Route exact path="/resource-operation-efficiency-form" render={props => <ResourceOperationEfficiencyForm resourceOpEfficiency={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateResourceOpEfficiency={(undefined) => { }}
            />} />
            <Route exact path="/plant-capacity-form" render={props => <PlantCapacityForm plantCapacity={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updatePlantCapacity={(undefined) => { }}
            />} />
            <Route exact path="/department-view" component={DepartmentsGrid} />
            <Route exact path="/department-form" render={props => <DepartmentsForm departmentData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateDepartment={(undefined) => { }}
            />} />


            <Route exact path="/sale-order-types-view" component={SaleOrderTypesGrid} />
            <Route exact path="/sale-order-types-form" render={props => <SaleOrderTypesForm SaleOrderTypeData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateItem={(undefined) => { }}
            />} />


            <Route exact path="/saleordertypes-view" component={SaleOrderTypesGrid} />
            <Route exact path="/saleordertypes-form" render={props => <SaleOrderTypesForm SaleOrderTypeData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateItem={(undefined) => { }}
            />} />



            {/* <Route exact path="/saleorderdetailview" component={SaleOrderDetailViewGrid} /> */}

            {/* <Route exact path="/destination-form" component={DestinationForm} /> */}
            <Route exact path="/suppliers-view" component={SuppliersGrid} />
            <Route exact path="/suppliers-form" render={props => <SuppliersForm
                supplierData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateSupplier={(undefined => { })}
            />
            } />

            <Route exact path="/hl-percentage-view" component={HlPercentagesGrid} />
            <Route exact path="/hl-percentages-form" render={props => <HlPercentagesForm
                hlpercentagesData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateHLpercentages={(undefined => { })}
            />
            } />
            <Route exact path="/hatcheries-view" component={HatcheriesGrid} />
            <Route exact path="/hatcheries-form" render={props => <HatcheriesForm
                hatcheryData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateHatchery={(undefined => { })}
            />
            } />
            <Route exact path="/level" component={LevelGrid} />
            <Route exact path="/level-form" render={props => <LevelForm levelData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateLevel={(undefined => { })}
            />
            } />
            <Route exact path="/pallet" component={PalletGrid} />
            <Route exact path="/pallet-form" render={props => <PalletForm palletData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updatePallet={(undefined => { })}
            />
            } />
            {/* ----------------packing masters---------- */}
            {((JSON.parse(localStorage.getItem('role'))===EmployeeRolesEnum.ADMIN)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER)||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON))&&<>
            <Route exact path="/rm-level-grid" component={RmLevelGrid} />
            <Route exact path="/rm-level-form" render={props => <RmLevelForm levelData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateLevel={(undefined => { })}
            />
            } />
            <Route exact path="/rm-zones-grid" component={RmZones} />
            <Route exact path="/soakstyle-grid" component={SoakStyleGrid} />
            <Route exact path="/soakstyle-form" render={props => <SoakStyleForm isUpdate={false} soakStyleData={undefined} closeForm={() => {}} UpdateSoakstyle={() => {}} setDrawerVisble={() => {}}/>} />

                <Route exact path="/rm-columns-grid" component={RmColumnsGrid} />
                <Route exact path="/rm-columns-form" render={props => <RmColumnsForm columnData={undefined}
                    isUpdate={false}
                    closeForm={() => { }}
                    updateColumn={(undefined => { })}
                />
                } />
                <Route exact path="/rm-rack-position" component={RmRackPositionGrid} />
                <Route exact path="/rm-rack-position-form" render={props => <RmRackPositionForm rackData={undefined}
                    isUpdate={false}
                    closeForm={() => { }}
                    updateRack={(undefined => { })}
                />
                } />
                <Route exact path="/rm-rack" component={RmRacksGrid} />
                <Route exact path="/rm-rack-form" render={props => <RmRacksForm rackData={undefined}
                    isUpdate={false}
                    closeForm={() => { }}
                    updateRack={(undefined => { })}
                />
                } />

            </>}

            <Route exact path="/zone" component={ZoneGrid} />
            <Route exact path="/zone-form" render={props => <ZoneForm zoneData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateZone={(undefined => { })}
            />
            } />
            <Route exact path="/rack-position" component={RackGrid} />
            <Route exact path="/rack-form" render={props => <RackForm rackData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateRack={(undefined => { })}
            />
            } />

            <Route exact path="/rack-master-grid" component={RacksMasterGrid} />
            <Route exact path="/pallet-capacity-grid" component={PalletCapacityGrid} />
            <Route exact path="/pallet-capacity-form" render={props => <PalletCapacityForm palletCapacityData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updatePalletCapacity={(undefined => { })}
            />
            } />

            <Route exact path="/rack-master-form" render={props => <RacksMasterForm rackData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateRack={(undefined => { })}
            />
            } />
            <Route exact path="/locations" component={LocationsGrid} />
            <Route exact path="/locations-form" render={props => <LocationsForm
                locationsData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateLocations={(undefined => { })}
            />
            } />
            <Route exact path="/column" component={ColumnsGrid} />
            <Route exact path="/columns-form" render={props => <ColumnsForm
                columnData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateColumn={(undefined => { })}
            />
            } />
            <Route exact path="/rack-endCustomer-mapping" component={RackEndcustomerMappingGrid} />
            <Route exact path="/rack-endCustomers-mapping-form" component={RackEndcustomerMappingForm} />
            <Route exact path="/transfer-action-form" component={TransferActionForm} />
            {/* <Route exact path="/valueaddition5-view" component={TypeOfValueAddition5Grid} /> */}
            {/* <Route exact path="/valueaddition5-form" render={props => <TypeOfValueAddition5Form productData={undefined}
        isUpdate={false}
        closeForm={() => { }}
        updatePoduct={(undefined) => { }}
    />} /> */}

            <Route exact path="/rm-tolerance-view" component={RmToleranceGrid} />
            <Route exact path="/rm-tolerance-form" render={props => <RmToleranceForm
                rmToleranceData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateRmTolerance={(undefined => { })}
            />
            } />
            <Route exact path="/holidays-calendar-form" component={HolidaysCalender} />
            <Route exact path="/holidays-calendar-view" component={HolidaysCalenderGrid} />

            <Route exact path="/employment-status-view" component={EmploymentStatusForm} />
            <Route exact path="/employment-status-form" component={EmploymentStatusGrid} />
            <Route exact path="/roles-view" component={RolesGrid} />
            <Route exact path="/roles-form" render={props => <RolesForm roleData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateRole={(undefined => { })} />
            } />
            <Route exact path="/vehicles" component={VehicleMasterGrid} />
            <Route exact path="/vehicles-form" component={VehicleMasterForm} />
            <Route exact path='/exchange-rate-form' component={ExchangeRatesForm} />
            <Route exact path='/exchange-rate-grid' component={ExchangeRatesGrid} />
            <Route exact path='/global-price-chart' component={GlobalPriceChartGrid} />

            <Route exact path="/sku-detail-view" component={SkuDetailView} />
            <Route exact path="/id-proofs" component={IdProofs} />
            <Route exact path="/id-proofs-grid" component={IdProofsGrid} />
            <Route exact path="/relations" component={Relations} />
            <Route exact path="/relations-grid" component={RelationsGrid} />
            <Route exact path="/expenses-category-form" component={ExpensesCategory} />
            <Route exact path="/expenses-category-view" component={ExpensesCategoryGrid} />
            <Route exact path="/expenses-sub-category-form" component={ExpensesSubCategory} />
            <Route exact path="/expenses-sub-category-view" component={ExpensesSubCategoryGrid} />
            <Route exact path="/loan-categories-grid" component={LoanCategoriesGrid} />
            <Route exact path="/loan-categories-form" component={LoanCategories} />
            <Route exact path='/complaints-view' component={ComplaintsGrid} />
            <Route exact path="/complaints" component={Complaints} />
            <Route exact path="/qualifications-view" component={QualificationsGrid} />
            <Route exact path="/qualifications-form" component={QualificationsForm} />
            <Route exact path="/skills-grid" component={SkillsGrid} />
            <Route exact path="/skills" component={Skills} />
            <Route exact path="/recruitment-mode-view" component={RecruitmentGrid} />
            <Route exact path="/recruitment-mode-form" render={props => <RecruitmentForm recruitmentData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateRecruitment={(undefined => { })} />
            } />



            <Route exact path="/route-view" component={RouteGrid} />
            <Route exact path="/route-form" render={props => <RouteForm routeData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateRoute={(undefined) => { }}
            />} />
            <Route exact path="/types-of-leaves-grid" component={TypesOfLeavesGrid} />
            <Route exact path="/types-of-leaves" component={TypesOfLeaves} />
            <Route exact path="/education-form" component={Education} />
            <Route exact path="/educations-view" component={EducationGrid} />
            <Route exact path='/certification-form' component={Certification} />
            <Route exact path='/certifications-view' component={CertificationGrid} />
            <Route exact path="/designation-grid" component={DesignationGrid} />
            <Route exact path="/designation" component={Designation} />
            <Route exact path="/item-damage-reasons-form" render={props => <ItemDamageReasonsForm itemdamagereasonsData={undefined}
                isUpdate={false}
                closeForm={() => { }}
                updateDetails={(undefined => { })} />
            } />

            {((
                [
                    EmployeeRolesEnum.ADMIN,
                    EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                    EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                    EmployeeRolesEnum.PACKAGING_SUPERVISOR,
                    EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER,
                    EmployeeRolesEnum.INDENT_PERSON,
                    EmployeeRolesEnum.ENQUIRY_PERSON,
                    EmployeeRolesEnum.REWEIGHTMENT_PERSON,
                    EmployeeRolesEnum.PRODUCTION_PERSON,
                    EmployeeRolesEnum.PLANT_SALES_MANAGER
                    



                    


                ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) ? <>

                {((
                    [
                        EmployeeRolesEnum.ADMIN,
                        EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                        EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER,
                    ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                        <Route exact path="/grn-rejection-reason-form" render={props => <GrnRejectionReasonsForm rejectionreasonData={undefined}
                            isUpdate={false}
                            closeForm={() => { }}
                            updateReason={(undefined => { })} />} />
                    </>

                }
                {((
                    [
                        EmployeeRolesEnum.ADMIN,
                        EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                        EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER,
                        EmployeeRolesEnum.PACKAGING_SUPERVISOR,
                        EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                        EmployeeRolesEnum.PLANT_SALES_MANAGER

                    ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                        <Route exact path="/grn-rejection-reason-view" component={GrnRejectionReasonsGrid} />
                        <Route exact path="/item-damage-reasons-view" component={ItemDamageReasonsGrid} />
                    </>
                }

                {((
                    [
                        EmployeeRolesEnum.ADMIN,
                        EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                        EmployeeRolesEnum.PACKAGING_SUPERVISOR,
                        EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                        EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER,
                        EmployeeRolesEnum.PLANT_SALES_MANAGER

                    ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                        <Route exact path="/item-category-view" component={ItemCategoriesGrid} />
                        <Route exact path="/item-sub-category-view" component={ItemSubCategoriesGrid} />
                    </>}
                {((
                    [
                        EmployeeRolesEnum.ADMIN,
                        EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                        EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                        EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER,
                        EmployeeRolesEnum.FINANCE_PERSON,
                        EmployeeRolesEnum.INDENT_PERSON,
                        EmployeeRolesEnum.REWEIGHTMENT_PERSON,
                        EmployeeRolesEnum.PRODUCTION_PERSON,
                        EmployeeRolesEnum.PLANT_SALES_MANAGER


                    ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                        <Route exact path="/item-category-form" render={props => <ItemCategoriesForm itemcategoryData={undefined}
                            isUpdate={false}
                            closeForm={() => { }}
                            updateDetails={(undefined => { })}
                        />} />
                        <Route exact path="/item-sub-category-form" render={props => <ItemSubCategoriesForm subCategoryData={undefined}
                            isUpdate={false}
                            closeForm={() => { }}
                            updateData={(undefined => { })}
                        />} />

                        <Route exact path="/TrimsView" component={TrimsGrid} />
                        <Route exact path="/trims-form" render={props => <TrimsForm
                            trimsData={undefined}
                            isUpdate={false}
                            closeForm={() => { }}
                            updateTrims={(undefined => { })}
                        />
                        } />
                        <Route exact path="/trims-configuration-form" component={TrimsConfigurationForm} />
                        <Route exact path="/types-form" render={props => <TypesForm
                            typesData={undefined}
                            isUpdate={false}
                            closeForm={() => { }}
                            updateDetails={(undefined => { })}
                        />
                        } />
                        <Route exact path="/items-form" render={props => <ItemsForm itemData={undefined}
                            isUpdate={false}
                            closeForm={() => { }}
                            updateItem={(undefined => { })} />
                        } />

                        <Route exact path="/sizes-form" render={props => <SizesForm sizesData={undefined}
                            isUpdate={false}
                            closeForm={() => { }}
                            updateSize={(undefined => { })}
                        />
                        } />
                        <Route exact path="/vendors-form" render={props => <VendorsForm vendorsData={undefined}
                            isUpdate={false}
                            closeForm={() => { }}
                            updateDetails={(undefined => { })}
                        />} />

                        <Route exact path="/vendorsPriceListView" component={VendorPriceListGrid} />
                        <Route exact path="/vendorsPriceListForm" render={props => <VendorPriceListForm />} />
                    </>}
                <Route exact path="/reasons-form" render={props => <ReasonsForm reasonsData={undefined}
                    isUpdate={false}
                    closeForm={() => { }}
                    updateReasons={(undefined => { })} />}
                />
                <Route exact path="/defect-grid" component={DefectGrid} />
                <Route exact path="/defect-form" render={props => <DefectForm defectData={undefined}
                    isUpdate={false}
                    closeForm={() => { }}
                    updateDefect={(undefined => { })} />}
                />
                <Route exact path="/Fg-pricelist-excel-upload" component={FgPricelistForm} />
                <Route exact path="/Fg-pricelist-view" component={FgPriceListGrid} />
                <Route exact path="/credit-print" component={DebitCreditPrint} />
                <Route exact path="/Fixed-components-rate-chart-view" component={FixedComponentsRateChartForm} />
                <Route exact path="/Fixed-components-rate-chart" component={FixedComponentsRateChartGrid} />
                <Route exact path="/rm-count-pricelist-grid" component={RmCountPriceListGrid} />
                <Route exact path="/rm-count-pricelist-form" component={RmCountPriceListForm} />
                <Route exact path="/deheading-peeling-form" component={DeheadingPeelingForm} />
                <Route exact path="/deheading-peeling-grid" component={DeheadingPeelingGrid} />
        
                <Route exact path="/freights-company-form" component={FreightsCompanyForm} />
                <Route exact path="/freights-company-view" component={FreightsCompanyView} />

                <Route exact path="/ocaen-freight-rates-excel-upload" component={OcaenFreightRatesExcelUpload} />
                <Route exact path="/ocaen-freight-rates-view" component={OcaenFreightRatesView} />
                <Route exact path="/farmers-excel-upload" component={FarmersExcelUpload} />
                <Route exact path="/farmers-view" component={FarmersGrid} />

                <Route exact path="/packing-material-prices-excel-upload" component={PackingMaterialPricesForm} />
                <Route exact path="/packing-material-prices-view" component={PackingMaterialPricesGrid} />
                <Route exact path="/bank-details-form" render={props => <BankDetailsForm bankData={undefined}
                    isUpdate={false}
                    closeForm={() => { }}
                    updateform={(undefined => { })}
                />} />
                <Route exact path="/bank-details-view" component={BankDetailsView} />

                <Route exact path="/stock-item-category-excel-upload" component={StockItemCategory} />
                <Route exact path="/stock-item-category-view" component={StockItemCategoryView} />

                <Route exact path="/vendor-banks-excel-upload" component={VendorBanksUpload} />
                <Route exact path="/vendor-banks-view" component={VendorBanksView} />


            </> : ''}
            {((
                    [
                        EmployeeRolesEnum.ADMIN,
                        EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                        EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                        EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER,EmployeeRolesEnum.PACKAGING_SUPERVISOR
                    ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && 
                    <>
                             <Route exact path="/sizes-view" component={SizesGrid} />
                             <Route exact path="/items-view" component={ItemsGrid} />
                             <Route exact path="/vendorsView" component={VendorsGrid} />
                             <Route exact path="/reasonsView" component={ReasonsGrid} />
                             <Route exact path="/types-grid" component={TypesGrid} />
                             <Route exact path="/trims-configuration-grid" component={TrimsMappingGrid} />
                    </>}
                    <Route exact path="/sale-budget-view" component={SaleBudgetGrid} />
                    <Route exact path="/sale-budget-excel-upload" component={SaleBudget} />
                    
                    <Route exact path="/rm-budget-view" component={RMBudgetGrid} />
                    <Route exact path="/rm-budget-excel-upload" component={RmBudget} />



        </>
    )
}

